export const deleteModalTexts = {
    delete: "activation.settings.delete.modal.button.delete",
    cancel: "common.cancel",
    body: "activation.settings.delete.modal.body.new",
    title: "activation.settings.delete.modal.title.new",
    checkLabel: "activation.settings.delete.modal.check.label",
    tooltipText: "activation.settings.delete.modal.tooltip.text",
};
